const i18n = {
  language: "English",

  emailPassword: require('./emailPassword.js'),
  user: require('./user.js'),

  menu: require('./menu.js'),

  accountSettings: require('./accountSettings.js'),

  csvAnalyzer: require('./csvAnalyzer.js'),

  words: require('./words.js'),
  ads: require('./ads.js'),

  tips: require('./tips.js'),

  filter: require('./filter.js'),

  table: require('./table.js'),

  multiSelect: require('./multiSelect.js'),
  loadFile: require('./loadFile.js'),

  save: require('./save.js'),

  order: require('./order.js'),

  premium: require('./premium.js'),

  translateColumnName(columnName) {
    return i18n.table[columnName] || columnName
  },
  translateColumnNames(columnNames) {
    return columnNames.map(i18n.translateColumnName)
  }

}

module.exports = i18n


// WEBPACK FOOTER //
// ../i18n/en/index.js